

  export const BootcampData = [

    {
    id: 0,
      title: "Movie-Magic",
      images:( process.env.PUBLIC_URL +  "/assets/images/repos/movie_magic.png"),
      alt: "sign-in screen",
      repo: "https://github.com/HowardDaniels/movie-magic" ,
      demo:"https://infinite-inlet-20359.herokuapp.com",
      url:"https://www.omdbapi.com/",
      poweredBy:"OMDB API",
      description: "This application allows the user to search and find movies and buddies.",
      myDuty:"Set up and configured user authentication using PassportJs and styling.",
      builtWith: "ExpressJs, NodeJs, PassportJs, MySQL, MomentsJs, Ajax, Sequelize, Dotenv, Console.Table, and Heroku.",
      status: "Completed"
    },
    {
      id: 1 ,
      title: "LingoLabs",
      images: ( process.env.PUBLIC_URL + "/assets/images/repos/lingolabs.png"),
      alt: "lingolabs website",
      repo:   "https://github.com/ShawnWhy/LingoLabs" ,
      demo:"https://shawnyulingolabsmaster.herokuapp.com/",
      description: "A website where users can browse and shop for stock website templates.",
      myDuty: "Creating the registration page, configuring the backend server, setting up private routes.",
      builtWith: "NodeJs, NPM, Expressjs, MongoDB, Reactjs, Mongoose, Passportjs, Socket.io, and Heroku.",
      url:"N/A",
      status: "Completed"
    },
    {
      id: 2,
      title: "Sports-Tracker",
      images: (process.env.PUBLIC_URL + "/assets/images/repos/sports_tracker.png"),
      alt: "figure of players playing verious sports",
      repo: "https://github.com/SportsWarriorsGWU/Sports-Tracker/" ,
      demo:"https://sportswarriorsgwu.github.io/Sports-Tracker/",
      description: "Sports-Tracker is a website dedicated to sports (NBA, NCAA, MLB, NHL) stats and news with a favorites funciton",
      myDuty: "My core responsibility utilizing Bootstrap and Bulma CSS to work with API call data.",
      builtWith: "Bootstrap, Bulma, Javascript, and JQuery.",
      url:"https://www.espn.com/apis/devcenter/docs/",
      status: "Completed"
    },
    {
      id: 3,
      title: "Note-Taker",
      images: ( process.env.PUBLIC_URL + "/assets/images/repos/note_taker.gif"),
      alt: "note taker",
      repo: "https://github.com/Kuiil7/Note-Taker" ,
      demo:"https://kuiil7.github.io/Note-Taker",
      description: "The purpose of this application is to write, save, and delete text notes using Atlas cloud service.",
      myDuty: "Created frontend using React and backend routing, schema using MongoDB Atlas cloud service.",
      builtWith: "Utilizing Bootstrap CSS framework, NodeJs, NPM, jQuery, Expressjs, Ajax, and JSON.",
      url:"N/A",
      status: "Completed"
    },
    {
      id: 4,
      title: "Eat-Da-Burger",
      images: ( process.env.PUBLIC_URL + "/assets/images/repos/eatdaburger.gif"),
      alt: "landing page with input box",
      repo: "https://github.com/Kuiil7/Node-Express-Handlebars" ,
      demo:"https://ancient-thicket-66505.herokuapp.com/",
      description: "Eat-Da-Burger!, a restaurant app that lets users input the names of burgers they would like to eat. Items are saved to a RDBMS SQL database utilizing CRUD funcitons with a client and server set up",
      myDuty: "Created frontend and backend.",
      builtWith: "NodeJs, Express Handlebars (MVC), and MySQL.",
      url:"N/A",
      status: "Completed"
    },


  ];

